import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import { Logo } from '../../components/Logo';
import { ProgressiveImage } from '../../components/ProgressiveImage';
import { Button } from '../../components/Button';
import { Timer } from '../../components/Timer';
import { useExternalLink } from '../../shared/useExternalLink';
import { amplitudeTracker } from '../../lib/shared/amplitude-tracker';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';
import imageSrc from '../../assets/images/main.png';
import bgSrc from '../../assets/images/bg-v2.png';
import styles from './PrelanderLimitedOfferPage.css';

const cx = classnames.bind(styles);

const MAIN_WEBSITE = 'https://powerplay.gg/counter-strike';
const INITIAL_PRELANDER = 'v2';

const TIMESTAMP = 1717200000000;

function PrelanderLimitedOfferPage() {
    const {url: subscriptionUrl} = useExternalLink('subscription/v4');

    useEffect(() => {
        logEvent(EVENT_TYPES.USER_PROPERTIES, {initialPrelander: INITIAL_PRELANDER});
        logEvent(EVENT_TYPES.PRELANDER_VISITED);
    }, []);

    return (
        <div className={styles.container}>
            <div
                className={styles.topBackground}
                style={{backgroundImage: `url(${bgSrc})`}}
            />
             <div className={styles.root}>
                <div className={styles.haaderWrapper}>
                    <header className={styles.header}>
                        <Logo className={styles.logo}/>
                        <Button
                            iconLeft={{type: 'login'}}
                            link={{
                                to: `${MAIN_WEBSITE}?auth=true&deviceId=${amplitudeTracker.getDeviceId()}`
                            }}
                            type='fourth'
                        />
                    </header>
                    <h1 className={styles.title}>
                        Free-to-play card fantasy game for counter-strike
                    </h1>
                    <div className={styles.divider} />
                </div>
                <main className={styles.main}>
                    <div className={styles.countdownBlock}>
                        <p className={styles.countdownBlockLabel}>For new users only</p>
                        <p className={styles.countdownBlockTitle}>Limited-time newcomer offer</p>
                        <Timer
                            expiryTimestamp={TIMESTAMP}
                        />
                    </div>
                    <div className={styles.offerBlock}>
                        <div className={styles.wrapper}>
                            <div className={styles.cardsBox}>
                                <ProgressiveImage
                                    alt='box cards'
                                    src={imageSrc}
                                    className={styles.cardsBoxImage}
                                />
                                <p className={styles.cardsBoxDescription}>
                                    <strong>50 game cards</strong> ultimate subscription box...
                                </p>
                            </div>
                            <p className={styles.additionalText}>
                                ...absolutely free is already waiting for you on the platform.
                            </p>
                        </div>
                        <div className={styles.startedBlock}>
                            <p className={styles.startedBlockTitle}>Getting Started</p>
                            <div className={styles.divider} />
                            <ul className={styles.list}>
                                <li className={styles.listItem}>
                                    <span>1.</span>
                                    <span>Sign up and claim your reward now.</span>
                                </li>
                                <li className={styles.listItem}>
                                    <span>2.</span>
                                    <span>With such a great head start, it's easy to win in the competitions and be rewarded with valuable prizes.</span>
                                </li>
                            </ul>
                            <Button
                                className={styles.button}
                                label='Sign up and claim your reward'
                                iconLeft={{
                                    type: 'lightning'
                                }}
                                link={{
                                    to: subscriptionUrl,
                                    target: 'custom'
                                }}
                            />
                        </div>
                    </div>
                </main>
                <footer className={styles.footer}>
                    <div className={cx('divider', 'center')} />
                    <p className={styles.copyrightText}>
                        Powerplay is developed independently and is not affiliated with or endorsed by the players, video game developers, esports teams or event holders depicted in the game.
                    </p>
                </footer>
            </div>
            <div
                className={styles.bottomBackground}
                style={{backgroundImage: `url(${bgSrc})`}}
            />
        </div>
    )
}

export {
    PrelanderLimitedOfferPage
}
